/**
 * Created by mykurisu on 2018/2/7.
 */
import React from 'react'
import {Toast, Toptips} from 'react-weui'
import axios from'axios'
import { browserHistory } from 'react-router'
import {WKRateStar, WKOwnDialog} from '../../components/wk'
import {GetRealLength} from '../../utils'
import '../../css/page/Evaluation.css'


class Evaluation extends React.Component {
    constructor() {
        super()
        document.title = '评价'
        this.state = {
            textValue: '',
            textValueNum: 500,
            rateValue: 0,
            product: {},
            had_submit: true,
            submiting: false,
            showWarn: false,
            isShowSuccessDialog:false,
            warnMsg: ''
        }
    }

    componentDidMount() {
        axios.get(`/api/invoice/${this.props.params.target_id}/evaluate/info`)
            .then(res => {
                if (res.data.code === 0) {
                    this.setState({
                        textValue: res.data.data.evaluate.description,
                        rateValue: res.data.data.evaluate.star,
                        product: res.data.data.evaluate.product,
                        had_submit: res.data.data.had_submit
                    }, () => {
                        if (res.data.data.evaluate.description !== '') {
                            this.setState({
                                textValueNum: 500 - Math.round(GetRealLength(this.state.textValue) / 2)
                            })
                        }
                    })
                }
            })
    }

    handelInput(e) {
        if (Math.round(GetRealLength(e.target.value) / 2) > 500) {
            return
        }

        this.setState({
            textValue: e.target.value
        }, () => {
            this.setState({
                textValueNum: 500 - Math.round(GetRealLength(this.state.textValue) / 2)
            })
        })
    }

    handleSelectRate(value) {
        this.setState({
            rateValue: value
        })
    }

    handleSubmit() {
        if (this.state.submiting || this.state.rateValue === 0 || this.state.textValue === '' || this.state.textValue.trim().length === 0) {
            let text = ''
            if (this.state.rateValue === 0) { text = '请选择星级评分' }
            if (this.state.textValue === '') { text = '请在评论区输入评论' }
            if (this.state.textValue.trim().length === 0) { text = '请在评论区输入评论' }
            this.setState({
                showWarn: true,
                warnMsg: text
            })
            this.tips = setTimeout(() => {
                this.setState({
                    showWarn: false,
                    warnMsg: ''
                })
            }, 2000)
            return
        }
        let data = new FormData()
        data.append('description', this.state.textValue)
        data.append('star', this.state.rateValue)
        this.setState({submiting: true})
        axios.post(`/api/invoice/${this.props.params.target_id}/evaluate/submit`, data)
            .then(res => {
                if (res.data.code === 0) {
                    this.setState({submiting: false, isShowSuccessDialog: true})
                } else {
                    this.setState({submiting: false, isShowSuccessDialog: false})
                    setTimeout(() => {
                        alert(res.data.msg)
                    }, 200)
                }
            })
    }

    renderRateText() {
        switch (Number(this.state.rateValue)) {
            case 1:
                return '非常差'
            case 2:
                return '差'
            case 3:
                return '一般'
            case 4:
                return '好'
            case 5:
                return '非常好'
            default:
                return ''
        }
    }

    onClickSuccessDialogOk() {
        if(browserHistory.getCurrentLocation().query._fromPath === 'mywk') {
            location.assign('/specials/mywk')
        }else {
            location.assign('/account/bought')
        }
    }

    render() {
        return (
            <div className="evaluation">
                <Toast 
                  show={this.state.submiting}
                  icon="loading"
                >
                  数据加载中
                </Toast>
                <Toptips type="warn" show={this.state.showWarn}>{this.state.warnMsg}</Toptips>
                <div className="evaluation__form">
                    <div className="cell form__title">
                        <div className="cell__title">
                            专栏
                        </div>
                        <div className="cell__content">
                            {this.state.product.name || ''}
                        </div>
                    </div>
                    <div className="cell form__star">
                        <div className="cell__title">
                            评分
                        </div>
                        <div className="cell__content">
                            <WKRateStar canClick={!this.state.had_submit}
                                        rateValue={this.state.rateValue || 0}
                                        handleSelectRate={(value) => this.handleSelectRate(value)}/>
                            <span style={{marginLeft: "10px", fontSize: '14px', color: '#FF9C00', position: 'relative', top: '-1px'}}>{this.renderRateText()}</span>
                        </div>
                    </div>
                    {this.state.had_submit ?
                        <div className="cell form__star">
                            <div className="cell__title">
                                评论
                            </div>
                            <div className="cell__content">
                                <pre>
                                    {this.state.textValue}
                                </pre>
                            </div>
                        </div>
                        :
                        <div className="cell form__comment">
                        <textarea rows="3"
                                  placeholder="请输入评论"
                                  value={this.state.textValue}
                                  onChange={(e) => this.handelInput(e)}/>
                            <div className="num">
                                {this.state.textValueNum}
                            </div>
                        </div>
                    }

                </div>
                {!this.state.had_submit &&
                <div className="evaluation__submit" onClick={() => this.handleSubmit()}>
                    提交
                </div>
                }
                <WKOwnDialog show={this.state.isShowSuccessDialog} type="ios"
                    title='已提交，谢谢评价'
                    buttons={[{
                    label: '好的',
                    onClick: () => this.onClickSuccessDialogOk()
                    }]}
                    >
                </WKOwnDialog>
            </div>
        )
    }
}

export default Evaluation



// WEBPACK FOOTER //
// ./src/pages/BoughtPage/Evaluation.js